module.exports = __webpack_public_path__ + "img/tech-sessions.688ea3e3.png";